// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:40:17

export default {
  "id": "ellie-chinese-new-year-celebration",
  "slug": "ellie-chinese-new-year-celebration",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e840aa4900b14adda1c9f4c9f97427be-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e840aa4900b14adda1c9f4c9f97427be/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Ellie Chinese New Year Celebration",
      "description": "Celebrate the beauty and traditions of the Chinese New Year with Ellie in this fun and engaging game! Known as the Lunar New Year, this festival is marked by vibrant decorations, delicious food, and exciting cultural customs. Join Ellie as she prepares for the celebration by dressing up in stunning traditional outfits, decorating her space, and participating in festive activities.",
      "instructions": "Left Mouse Button Click",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "beauty",
        "cutedressup",
        "fashion",
        "girls",
        "girlsdressup"
      ]
    },
    "zh-CN": {
      "title": "艾莉春节庆祝活动",
      "description": "庆祝中国新年的美丽与传统，与艾莉一起在这款有趣且引人入胜的游戏中欢庆！被称为农历新年，这个节日以鲜艳的装饰、美味的食物和激动人心的文化习俗为标志。跟随艾莉，她将穿上华丽的传统服饰，装饰她的空间，并参与节日活动，为庆祝活动做准备。",
      "instructions": "左鼠标按钮点击",
      "genres": [
        "装扮"
      ],
      "tags": [
        "美丽",
        "可爱装扮",
        "时尚",
        "女孩",
        "女孩装扮"
      ]
    },
    "zh-TW": {
      "title": "艾莉中國新年慶典",
      "description": "與艾莉一起慶祝中國新年的美麗與傳統！這個節日被稱為陰曆新年，以其生動的裝飾、美味的食物和刺激的文化習俗而聞名。加入艾莉的行列，她將為慶祝準備，穿上令人驚艷的傳統服裝，裝飾她的空間，並參與節慶活動。",
      "instructions": "左鍵點擊",
      "genres": [
        "装扮"
      ],
      "tags": [
        "美麗",
        "可愛打扮",
        "時尚",
        "女孩",
        "女孩打扮"
      ]
    },
    "zh-HK": {
      "title": "艾莉中國新年慶祝",
      "description": "慶祝中國新年的美麗與傳統，與Ellie一起參與這款有趣又吸引人的遊戲！這個節日又稱為陽曆新年，以生動的裝飾、美味的食物和充滿活力的文化習俗為特徵。隨著Ellie準備歡樂的慶祝活動，她將穿上迷人的傳統服裝，裝飾她的空間，並參與節日活動。",
      "instructions": "左鍵按鈕按鍵",
      "genres": [
        "裝飾服裝"
      ],
      "tags": [
        "美麗",
        "可愛打扮",
        "時尚",
        "女兒",
        "女兒打扮"
      ]
    },
    "ja": {
      "title": "エリー中国新年祭り",
      "description": "中国新年の美しさと伝統をエリーと共に祝いましょう！陰陽新年として知られるこの祭りは、鮮やかな装飾、美味しい料理、そして刺激的な文化習慣で特徴づけられています。エリーが素晴らしい伝統的な服装を身に纏い、空間を飾り付け、お祭り活動に参加する準備をするのを見て、彼女に加わってください。",
      "instructions": "左ボタンクリック",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "美しさ",
        "可愛いドレスアップ",
        "ファッション",
        "少女",
        "少女ドレスアップ"
      ]
    },
    "ko": {
      "title": "엘리 중국 신년庆典",
      "description": "이 게임에서 엘리와 함께 중국 신년의 아름다움과 전통을 축하하세요! 달력 신년으로 알려진 이 축제는 생동감 넘치는 장식, 맛있는 음식, 흥미진진한 문화적 전통으로 특징づ여져 있습니다. 엘리와 함께 축제 준비를 위해 장관이 되는 전통 의상을 입고, 공간을 장식하고, 축제 활동에 참여하세요!",
      "instructions": "왼쪽 마우스 버튼 클릭",
      "genres": [
        "의상차림"
      ],
      "tags": [
        "美",
        "귀여운 드레스업",
        "패션",
        "소녀",
        "소녀 드레스업"
      ]
    },
    "fr": {
      "title": "Fête du Nouvel An Chinois d'Ellie",
      "description": "Félicitez la beauté et les traditions du Nouvel An chinois avec Ellie dans ce jeu amusant et captivant ! Connu sous le nom de Nouvel An lunaire, ce festival est marqué par des décorations vibrantes, de délicieuses nourritures et des coutumes culturelles passionnantes. Rejoignez Ellie alors qu'elle se prépare à la célébration en s'habillant de splendides tenues traditionnelles, en décorant son espace et en participant à des activités festives.",
      "instructions": "Clic gauche de la souris",
      "genres": [
        "Vêtements de déguisement"
      ],
      "tags": [
        "beauté",
        "déguisement mignon",
        "mode",
        "filles",
        "déguisement filles"
      ]
    }
  }
};
